export default __webpack_public_path__ + "static/group2-bf76b23b558a4b3fe7b39da663b33caa.png";